import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import React from "react";

/**
 * ForceEndDialog Component
 * 
 * A confirmation dialog for force ending a user subscription.
 * Displays a warning message and requires confirmation before proceeding.
 * 
 * @param {boolean} open - Controls the visibility of the dialog
 * @param {function} onClose - Callback function when dialog is closed
 * @param {function} onConfirm - Callback function when user confirms force end
 * @param {boolean} forceEnding - Indicates if force end operation is in progress
 */
const ForceEndDialog = ({ open, onClose, onConfirm, forceEnding }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                Force End Subscription
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to force end this subscription? This action cannot be undone and will immediately cancel the user's subscription.
                </DialogContentText>
                <Alert severity="warning" sx={{ mt: 2 }}>
                    This action is for testing only.
                </Alert>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button onClick={onClose} variant="outlined">
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color="error"
                    disabled={forceEnding}
                >
                    {forceEnding ? 'Force Ending...' : 'Yes, Force End'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ForceEndDialog;

